import type { ReactNode } from "react";
import { FeatureCard } from "../../site/components/FeatureCard";

interface PageProps {
  readonly eyebrow?: string;
  readonly title: string;
  readonly intro: string;
  readonly children?: ReactNode;
}

export function Page({ eyebrow, title, intro, children }: PageProps) {
  return (
    <main className="page-shell">
      <section className="page-heading">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        <p>{intro}</p>
      </section>
      {children}
    </main>
  );
}

interface FeatureGridProps {
  readonly items: readonly {
    readonly title: string;
    readonly body: string;
  }[];
}

export function FeatureGrid({ items }: FeatureGridProps) {
  return (
    <section className="feature-grid">
      {items.map((item) => (
        <FeatureCard body={item.body} key={item.title} title={item.title} />
      ))}
    </section>
  );
}

interface NoteBandProps {
  readonly title: string;
  readonly children: ReactNode;
}

export function NoteBand({ title, children }: NoteBandProps) {
  return (
    <section className="note-band">
      <h2>{title}</h2>
      <div>{children}</div>
    </section>
  );
}
